import { render, staticRenderFns } from "./DirectorDetails.vue?vue&type=template&id=4805c0e8&"
import script from "./DirectorDetails.vue?vue&type=script&lang=js&"
export * from "./DirectorDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports